import React from "react";

import {
    MobileFacets,
    MobileFacetsProps,
} from "@components/Search/SearchResults/StateComponents/Facets/MobileFacets/mobileFacets.container";
import { Facets } from "@components/Search/SearchResults/StateComponents/Facets/facets.container";

const ProductFacets = () => <Facets component={"PRODUCT_FACETS"} />;
const MobileProductFacets = (props: MobileFacetsProps) => (
    <MobileFacets {...props} FacetsComponent={ProductFacets} />
);

export { ProductFacets, MobileProductFacets };
